import React from 'react';
import { cn } from '@/lib/utils';
import { CLUB_STATUS } from '@/types/club.model';

interface StatusConfig {
  label: string;
  bg: string;
  text: string;
  dot: string;
}

const STATUS_CONFIG: Record<CLUB_STATUS, StatusConfig> = {
  [CLUB_STATUS.ENABLED]: {
    label: 'Habilitado',
    bg: 'bg-gc-greenSoft',
    text: 'text-gc-greenInk',
    dot: 'bg-gc-greenDot',
  },
  [CLUB_STATUS.IN_PROGRESS]: {
    label: 'En progreso',
    bg: 'bg-gc-amberSoft',
    text: 'text-gc-amberInk',
    dot: 'bg-gc-amberDot',
  },
  [CLUB_STATUS.DISABLED]: {
    label: 'Deshabilitado',
    bg: 'bg-gc-graySoft',
    text: 'text-gc-grayInk',
    dot: 'bg-gc-grayDot',
  },
};

interface StatusPillProps {
  status: CLUB_STATUS;
  size?: 'm' | 's';
}

export const StatusPill: React.FC<StatusPillProps> = ({ status, size = 'm' }) => {
  const config = STATUS_CONFIG[status];

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full whitespace-nowrap font-semibold',
        config.bg,
        config.text,
        size === 'm' ? 'px-2.5 py-1 text-[12.5px]' : 'px-2 py-[3px] text-[11.5px]',
      )}
    >
      <span className={cn('h-[7px] w-[7px] rounded-full shrink-0', config.dot)} />
      {config.label}
    </span>
  );
};
